import { IKeyFigureGroup, IKeyFiguresData, ITags, ITagsData } from "src/api/server/extended-search.types";
import { markKeyFiguresWithPopularIndication } from "src/components/pages/search/utils/map-key-figures";

const TAG_GROUP_KEYS = ["basics", "rewards", "tradings", "investmentHorizon", "investmentRegion", "alphaBeta"] as const;

const filterPopularTags = (tags: ITags): ITags =>
    TAG_GROUP_KEYS.reduce((popularTagGroups, groupKey) => {
        popularTagGroups[groupKey] = { ...tags[groupKey], tags: tags[groupKey].tags.filter(tag => tag.isPopular) };
        return popularTagGroups;
    }, {} as ITags);

export interface IPopularFilters {
    popularKeyFiguresGroup: IKeyFigureGroup;
    keyFiguresGroupsWithIsPopularIndication: IKeyFigureGroup[];
    popularTags: ITags;
}

export const getPopularFilters = (tagsData: ITagsData, keyFiguresData: IKeyFiguresData): IPopularFilters => {
    const popularKeyFiguresGroup: IKeyFigureGroup = {
        ...keyFiguresData.popularKeyFiguresGroup,
        keyFigures: keyFiguresData.popularKeyFiguresGroup.keyFigures.map(keyFigure => ({ ...keyFigure, isPopular: true })),
    };

    const keyFiguresGroupsWithIsPopularIndication = keyFiguresData.keyFiguresGroups.map(keyFiguresGroup => ({
        ...keyFiguresGroup,
        keyFigures: markKeyFiguresWithPopularIndication(keyFiguresGroup.keyFigures, popularKeyFiguresGroup.keyFigures),
    }));

    return {
        popularKeyFiguresGroup,
        keyFiguresGroupsWithIsPopularIndication,
        popularTags: filterPopularTags(tagsData.tags),
    };
};
